(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["latest-article"]) return;
  try {
    
window.addEventListener('scroll', function(){
   const swiperJs = document.createElement('script'),
       swiperLinkStyle = document.createElement('link')

swiperJs.src = 'https://unpkg.com/swiper/swiper-bundle.min.js'
swiperJs.async = true
swiperLinkStyle.href="https://unpkg.com/swiper/swiper-bundle.min.css"
swiperLinkStyle.rel = 'stylesheet'

document.querySelector('head').append(swiperLinkStyle)
document.querySelector('body').append(swiperJs)

swiperJs.onload = function(){
      console.log(swiperJs)
console.log(swiperLinkStyle)

        const latestSliderWrap = document.querySelector('.interested-articles-swiper.swiper')

    new Swiper(latestSliderWrap, {
      slidesPerView: 1,
      spaceBetween:8,
      speed:700,
      breakpoints:{
        320:{
          slidesPerView: 1.2,
          spaceBetween:10
        },
        481:{
          slidesPerView:2.1,
          spaceBetween:14
        },
        768:{
          slidesPerView:2.2,
          spaceBetween:15
        },
        1280:{
          slidesPerView: 3,
          spaceBetween: 20
        }
      }
    })
    }
}, {once:true})

if(document.querySelector('.interested-articles-swiper .swiper-slide') == null){
  document.querySelector('.shopify-section.interested-articles').style.display = 'none'
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-blog"]) return;
  try {
    
window.addEventListener('scroll', function(){
const work = document.querySelector("#workOuterShell");
const items = Array.from(work.querySelectorAll(".main-blog__item"));
const loadMore = document.getElementById("loadMore");
const loadMoreWrap = document.querySelector(".main-blog__ldmore-wrap");
maxItems = 9;
loadItems = 9;
hiddenClass = "hiddenStyle";
hiddenItems = Array.from(document.querySelectorAll(".hiddenStyle"));
items.forEach(function (item, index) {
if (index > maxItems - 1) {
item.classList.add(hiddenClass);
}
});
loadMore.addEventListener("click", function () {
[].forEach.call(document.querySelectorAll("." + hiddenClass), function (
item,
index
) {
if (index < loadItems) {
item.classList.remove(hiddenClass);
}
if (document.querySelectorAll("." + hiddenClass).length === 0) {
loadMoreWrap.style.display = "none";
}
});
});
if(document.querySelectorAll('.main-blog__item').length < 10){
document.querySelector('.main-blog__ldmore-wrap').style.display="none"
} else{
console.log('testcoll')
}
}, {once:true})

  } catch(e) { console.error(e); }
})();
})();
